<template>
  <section>
    <el-row class="condition-bar">
      <el-col :span="24" class>
        <el-col :span="6">
          <label>油站</label>
          <el-select v-model="params.stationId" class="input-width" size="small" placeholder="请选择">
            <el-option v-if="isAllStation === 1" label="全部" value />
            <el-option
              v-for="(item, index) in stationLists"
              :key="index"
              :label="item.stationName"
              :value="item.stationId"
            />
          </el-select>
        </el-col>
        <el-col :span="6">
          <label>油品</label>
          <el-select
            v-model="params.prodId"
            class="input-width"
            clearable
            size="small"
            placeholder="请选择"
          >
            <el-option label="全部" value />
            <el-option
              v-for="(item, index) in prodList"
              :key="index"
              :label="item.prodStandard + '-' + item.prodName"
              :value="item.prodId"
            />
          </el-select>
        </el-col>
        <el-col :span="12">
          <label>时间</label>
          <el-date-picker
            v-model="btime"
            :default-time="['00:00:00','23:59:59']"
            size="small"
            type="datetimerange"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd HH:mm:ss"
            format="yyyy-MM-dd HH:mm:ss"
          />
        </el-col>
      </el-col>
      <el-col :span="24">
        <div class="button-group">
          <el-button
            v-waves
            class="filter-item"
            size="small"
            type="info"
            icon="el-icon-document"
            @click="handleFuelToExcel"
          >导出</el-button>
          <el-button
            type="primary"
            size="small"
            icon="el-icon-search"
            @click="
              params.pn = 1;
              getPage();
            "
          >搜索</el-button>
        </div>
      </el-col>
    </el-row>
    <el-row class="boss-table" style="padding: 1%">
      <el-col :span="24">
        <el-table v-loading="loading" :data="tableData" style="width: 100%;">
          <el-table-column prop="stationName" label="油站" />
          <el-table-column prop="tankNo" label="油罐编号" />
          <el-table-column prop="prodName" label="油品" />
          <el-table-column prop="outKg" label="出库单数量(kg)" />
          <el-table-column prop="inKg" label="实际进油(kg)" />
          <el-table-column prop="inDensity" label="实测密度(g/cm³)" />
          <el-table-column prop="inVol" label="进油体积(L)" />
          <el-table-column label="操作" width="200">
            <template slot-scope="scope">
              <span
                style="color: #009bf0;cursor: pointer;margin-right:10px;"
                @click="remove(scope.row.id,scope.$index)"
              >删除</span>
              <span style="color: #009bf0;cursor: pointer" @click="checkDetails(scope.row)">详情</span>
            </template>
          </el-table-column>
        </el-table>
        <v-pageBox :params="params" @pageBox="pageBox" />
      </el-col>
    </el-row>
    <!--详情-->
    <el-dialog :visible.sync="recordDetailsVisible" title="详情" width="700px" style="padding: 10px">
      <div class="item">
        <div class="sunhao">
          <div class="neirong">
            <p>进油时间</p>
            <div>
              <p>{{ detailsData.inTime }}</p>
            </div>
          </div>
          <div class="right" />
        </div>
      </div>
      <div class="item">
        <h4>发货信息</h4>
        <div class="content">
          <div class="left">
            <p>发货单位</p>
            <span>{{ detailsData.sendUnit }}</span>
          </div>
          <div class="right">
            <p>发油类型</p>
            <span v-if="detailsData.sendOilType == 1">销售待保管订单</span>
            <span v-if="detailsData.sendOilType == 2">现销现提订单</span>
            <span v-if="detailsData.sendOilType == 3">其他</span>
          </div>
        </div>
      </div>
      <div class="item">
        <h4>提货信息</h4>
        <div class="contents">
          <div class="left1">
            <div>
              <p style="flex:2">提货日期</p>
              <p v-if="detailsData.hasTakeInfo == 1" style="flex:6">{{ detailsData.takeDate | jie }}</p>
              <p v-if="detailsData.hasTakeInfo == 0" style="flex:6" />
            </div>
            <div>
              <p style="flex:2">提油单位</p>
              <p style="flex:6">{{ detailsData.takeUnit }}</p>
            </div>
          </div>
          <div class="right1">
            <div>
              <p style="flex:2">提货单号</p>
              <p style="flex:6">{{ detailsData.takeNo }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="item">
        <h4>出库单信息</h4>
        <div class="contents">
          <div class="left2">
            <div>
              <p style="flex:2">出库单号</p>
              <p style="flex:6">{{ detailsData.odo }}</p>
            </div>
            <div>
              <p style="flex:2">站点运营商</p>
              <p style="flex:6">{{ detailsData.stationOperator }}</p>
            </div>
            <div>
              <p style="flex:2">铅封</p>
              <p style="flex:6">{{ detailsData.leadSealing }}</p>
            </div>
            <div>
              <p style="flex:2">出库照片</p>
              <div class="photo">
                <ul>
                  <li v-for="item in outPicUrl" :key="item">
                    <img :src="item" alt />
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="right2" style="height:90px">
            <div>
              <p>出库数量</p>
              <div>
                <p>{{ detailsData.outKg }}</p>
                <p style="text-align:right;margin-right: 20px;">kg</p>
              </div>
            </div>
            <div>
              <p>车/船号</p>
              <div>
                <p>{{ detailsData.carShipNo }}</p>
              </div>
            </div>
            <div>
              <p>出库密度</p>
              <div>
                <p>{{ detailsData.outDensity }}</p>
                <p style="text-align:right;margin-right: 20px;">g/cm³</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="item">
        <h4>入库信息</h4>
        <div class="contents">
          <div class="right2">
            <div style="height:30px">
              <p>实测密度</p>
              <div>
                <p>{{ detailsData.inDensity }}</p>
                <p style="text-align:right;margin-right: 20px;">g/cm³</p>
              </div>
            </div>
            <div style="height:30px">
              <p>入罐升数</p>
              <div>
                <p>{{ detailsData.inVol }}</p>
                <p style="text-align:right;margin-right: 20px;">L</p>
              </div>
            </div>
            <div>
              <p style="flex:2">过磅照片</p>
              <div class="photo">
                <ul>
                  <li v-for="item in inPicUrl" :key="item">
                    <img :src="item" alt />
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="right2">
            <div style="height:30px">
              <p>入罐数量</p>
              <div>
                <p>{{ detailsData.inKg }}</p>
                <p style="text-align:right;margin-right: 20px;">kg</p>
              </div>
            </div>
            <div style="height:30px">
              <p>入罐油温</p>
              <div>
                <p>{{ detailsData.inTemperature }}</p>
                <p style="text-align:right;margin-right: 20px;">℃</p>
              </div>
            </div>
            <div>
              <p style="flex:2">油密度照片</p>
              <div class="photo">
                <ul>
                  <li v-for="item in oilDensityPicUrl" :key="item">
                    <img :src="item" alt />
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="item">
        <h4>损耗信息</h4>
        <div class="sunhao">
          <div class="neirong">
            <p>损耗</p>
            <div>
              <p>{{ detailsData.waste }}</p>
              <p style="text-align:right;margin-right: 20px;">kg</p>
            </div>
          </div>
          <div class="right" />
        </div>
      </div>
      <div class="item">
        <h4>备注</h4>
        <div class="sunhao">
          <div class="neirong" style="display:flex;flex-direction:column">
            <div style="flex:1;display:flex;padding: 3px 0 3px 0;">
              <p style="flex:2;">备注</p>
              <div style="flex:6;">
                <p>{{ detailsData.memo }}</p>
              </div>
            </div>
            <div style="flex:1;display:flex;padding: 3px 0 3px 0;">
              <p style="flex:2;">备注照片</p>
              <div class="photo">
                <ul>
                  <li v-for="item in memoPicUrl" :key="item">
                    <img :src="item" alt />
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="right" />
        </div>
      </div>
      <div class="btn" style="text-align:center;margin-top:30px;">
        <el-button type="primary" @click="close">关闭</el-button>
      </div>
      <!-- <header style="padding: 0 10px;font-weight: bold">
        <p>
          {{ detailsData.stationName }}
          <span style="padding-left: 3%">{{ detailsData.tankNo }}号罐</span>
          <span style="padding-left: 3%">{{ detailsData.prodName }}</span>
        </p>
      </header>-->

      <!-- <div class="content" style="padding: 10px">
        <el-row>
          <el-col :span="24" class="bottomSty">
            <el-col :span="12">
              <span>进油时间</span>
            </el-col>
            <el-col :span="12" style="text-align: right">
              <span>{{ detailsData.inTime }}</span>
            </el-col>
          </el-col>
          <el-col :span="24" class="bottomSty">
            <el-col :span="12">
              <span>出库单号</span>
            </el-col>
            <el-col :span="12" style="text-align: right">
              <span>{{ detailsData.odo }}</span>
            </el-col>
          </el-col>
          <el-col :span="24" class="bottomSty">
            <el-col :span="12">
              <span>出库数量(kg)</span>
            </el-col>
            <el-col :span="12" style="text-align: right">
              <span>{{ detailsData.outKg }}</span>
            </el-col>
          </el-col>
          <el-col :span="24" class="bottomSty">
            <el-col :span="12">
              <span>实测密度(g/cm³)</span>
            </el-col>
            <el-col :span="12" style="text-align: right">
              <span>{{ detailsData.inDensity }}</span>
            </el-col>
          </el-col>
          <el-col :span="24" class="bottomSty">
            <el-col :span="12">
              <span>入库数量(kg)</span>
            </el-col>
            <el-col :span="12" style="text-align: right">
              <span>{{ detailsData.inKg }}</span>
            </el-col>
          </el-col>
          <el-col :span="24" class="bottomSty">
            <el-col :span="12">
              <span>备注</span>
            </el-col>
            <el-col :span="12" style="text-align: right">
              <span>{{ detailsData.memo }}</span>
            </el-col>
          </el-col>
          <el-col :span="24">
            <el-col :span="8">
              <el-card :body-style="{ padding: '0px' }">
                <img :src="detailsData.outPicUrl" class="image" >
                <div style="padding: 14px;text-align: center">
      <span>出库照片</span>-->

      <!--<div class="bottom clearfix">
                    <time class="time"></time>
                    <el-button type="text" class="button">操作按钮</el-button>
      </div>-->

      <!-- </div>
              </el-card>
            </el-col>
            <el-col :span="8">
              <el-card :body-style="{ padding: '0px' }">
                <img :src="detailsData.inPicUrl" class="image" >
                <div style="padding: 14px;text-align: center">
      <span>过磅照片</span>-->

      <!-- <div class="bottom clearfix">
                    <time class="time"></time>
                    <el-button type="text" class="button">操作按钮</el-button>
      </div>-->

      <!-- </div>
              </el-card>
            </el-col>
            <el-col :span="8">
              <el-card :body-style="{ padding: '0px' }">
                <img :src="detailsData.memoPicUrl" class="image" >
                <div style="padding: 14px;text-align: center">
      <span>备注照片</span>-->

      <!--<div class="bottom clearfix">
                    <time class="time"></time>
                    <el-button type="text" class="button">操作按钮</el-button>
      </div>-->

      <!-- </div>
              </el-card>
            </el-col>
          </el-col>
        </el-row>
      </div>-->
    </el-dialog>
  </section>
</template>
<script>
import PageBox from '@/components/paging/PageBox'
import { stationList } from '@/api/station' // get油站
import { listProd } from '@/api/product' // get油品
import { fuelRecordToExcel } from '@/api/download'
import { getInOilRecord } from '@/api/stockManage' // 预警值设置
import { getDateOfDay } from '../../utils'
import { getEmpInfo } from '@/utils/auth'
import { downloadFile } from '@/utils/file'
import { oilHistoryRecordToExcel } from '@/api/download'
import { del } from '@/api/remove'
export default {
  components: {
    'v-pageBox': PageBox
  },
  filters: {
    jie(val) {
      var arr = val.split(' ')
      return arr[0]
    }
  },
  data() {
    return {
      btime: getDateOfDay(0),
      loading: true,
      url:
        'https://www.baidu.com/link?url=p1nNL_uPzs7jl-byudMifikA9EjPa9fkPico3GststJ4-yugBsizr1XnLfdYk1SgKtrLcP1Vwms08Z45dxe6O05X6sl4VKzXVksCxX2_0tzj-Vt4Id8J-upo6U9n04bilt72YPzoJa0sO7j3IEgrKdRsyuDMbhnQpVPtChbAvBqVbOxw4Dv3vgLnJFUuOwVb7rlZcjgHAy7r4WtUKnYMR5v6-hd9OmGqeEZb1T419dKx1kLZ3xYvNoo0by-n310Ar9zK8Y9ycgSsVmmsslalR0bDubcVNjq7zUc8cr-rD8RUQmRDvtkyHX9k-arKeV8xReQHMGaE_guDRXPAoYVLI_9_5MRK1g9536b6YZy_pmKBG7krjYZEl2wOkqM4IiJPzL9uWmJODgTmBw7IzZw45PhpbuNT2iYRoEHhLUTK9X1fA4JgI0e6cyfa3BjKH4GXjQ-Toj29wqEVkn3JwJpN-uviRDCbafnnFL8t-1L-6j7wiGN7WkO5NQrTCmAfvTWCibr-7v25dhnhJWJGkh-kztZxa17mlvtsVP5tch_BCjtdK8gnbaJe2awZ0HvhnhRuYVnVqpn6iDZCvmJX41nLEKLk_NzxRNZpBU0JMkHSwd_&timg=https%3A%2F%2Fss0.bdstatic.com%2F94oJfD_bAAcT8t7mm9GUKT-xh_%2Ftimg%3Fimage%26quality%3D100%26size%3Db4000_4000%26sec%3D1588910057%26di%3Dbbeb7910511cc71ccb2c1773a343039c%26src%3Dhttp%3A%2F%2Fa0.att.hudong.com%2F64%2F76%2F20300001349415131407760417677.jpg&click_t=1588910707246&s_info=1583_757&wd=&eqid=f007fc7c0009da92000000065eb4d7e9',
      params: {
        pn: 1,
        ps: 20,
        pc: 100,
        stationId: getEmpInfo().isAllStation === 0 ? getEmpInfo().stationId : ''
      }, // 查询条件参数
      isAllStation: getEmpInfo().isAllStation,
      stationLists: [],
      prodList: [],
      tableData: [],
      recordDetailsVisible: false,
      detailsData: {},
      inPicUrl: [],
      oilDensityPicUrl: [],
      memoPicUrl: [],
      outPicUrl: []
    }
  },
  created() {
    // 油站列表
    stationList({ ps: 100 }).then(response => {
      const row = response.data
      console.log(row)
      if (row.data.items) {
        const obj = row.data.items
        for (const key in obj) {
          this.stationLists.push({
            stationId: obj[key].stationId,
            stationName: obj[key].stationName
          })
        }
      }
    })
    // 油品信息
    listProd({}).then(resp => {
      this.prodList = resp.data.data
    })
    this.getPage()
  },
  methods: {
    // 接受分页子组件参数
    handleFuelToExcel() {
      let loadingIns
      this.$confirm('确定导出加油记录为excel吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        loading: true,
        type: 'info'
      })
        .then(() => {
          const loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          })
          loadingIns = loading
          console.log(this.params)

          oilHistoryRecordToExcel(this.params)
            .then(response => {
              console.log(response)

              if (response.status == 200) {
                const type = response.headers['content-type']
                // response.setHeader("Content-Type", "application/vnd.ms-excel"); //type必须和后端的type一致
                downloadFile(response, type)
                loadingIns.close()
              }
            })
            .catch(e => {
              console.log(e)

              this.$message({
                type: 'warning',
                message: '导出失败！ 原因：' + e
              })
              loadingIns.close()
            })
        })
        .catch(() => {
          this.$message({
            type: 'warning',
            message: '取消导出！'
          })
          loadingIns.close()
        })
    },
    pageBox(...data) {
      console.log(data)
      const pageBoxData = data
      console.log(pageBoxData)
      if (pageBoxData[0] === 'ps') {
        this.params.ps = pageBoxData[1]
      } else {
        this.params.pn = pageBoxData[1]
      }
      console.log(this.params)
      this.getPage()
    },
    close() {
      this.recordDetailsVisible = false
    },
    // 进油记录
    getPage() {
      if (this.btime) {
        this.params.startTime = this.btime[0]
        this.params.endTime = this.btime[1]
      }
      getInOilRecord(this.params).then(res => {
        if (res.data.code == 0) {
          console.log(res)
          this.tableData = res.data.data.items
          this.params.pc = res.data.data.totalItems
          this.loading = false
        }
      })
    },
    remove(data, index) {
      // console.log(data,index);

      // console.log(this.tableData);

      this.$confirm('确定删除进油信息？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        dangerouslyUseHTMLString: true,
        message:
          '<h5 style="font-size: 16px;margin: 20px 0 0 0">确定删除进油信息？</h5><p style="color: gray;font-size: 14px;">删除之后不可恢复</p>',
        type: 'warning'
      })
        .then(() => {
          del({ id: data }).then(res => {
            if (res.data.code == 0) {
              this.$message({
                type: 'success',
                message: '已成功删除'
              })
              this.tableData.splice(index, 1)
            }
          })
        })
        .catch(() => {
          // console.log(2);

          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
      // this.tableData.splice(data,1)
    },
    // 查看详情
    checkDetails(data) {
      this.detailsData = data
      console.log(data)

      var arr = Object.keys(data)
      // console.log(arr.indexOf('outPicUrl'),arr.indexOf('inPicUrl'),arr.indexOf('oilDensityPicUrl'),arr.indexOf('memoPicUrl'));
      // console.log(arr.indexOf('inPicUrl')!=-1);
      this.outPicUrl = []
      this.inPicUrl = []
      this.oilDensityPicUrl = []
      this.memoPicUrl = []
      if (arr.indexOf('inPicUrl') != -1) {
        if (
          data.inPicUrl.constructor == String &&
          data.inPicUrl.indexOf('|||') != -1
        ) {
          var arrs = data.inPicUrl.split('|||')
          for (let i = 0; i < arrs.length; i++) {
            this.inPicUrl.push(arrs[i])
          }
        } else {
          this.inPicUrl.push(data.inPicUrl)
        }
      } else {
        this.inPicUrl = []
      }
      if (arr.indexOf('oilDensityPicUrl') != -1) {
        if (
          data.oilDensityPicUrl.constructor == String &&
          data.oilDensityPicUrl.indexOf('|||') != -1
        ) {
          var arr1 = data.oilDensityPicUrl.split('|||')
          for (let i = 0; i < arr1.length; i++) {
            this.oilDensityPicUrl.push(arr1[i])
          }
        } else {
          this.oilDensityPicUrl.push(data.oilDensityPicUrl)
        }
      } else {
        this.oilDensityPicUrl = []
      }
      if (arr.indexOf('memoPicUrl') != -1) {
        if (
          data.memoPicUrl.constructor == String &&
          data.memoPicUrl.indexOf('|||') != -1
        ) {
          var arr2 = data.memoPicUrl.split('|||')
          for (let i = 0; i < arr2.length; i++) {
            this.memoPicUrl.push(arr2[i])
          }
        } else {
          this.memoPicUrl.push(data.memoPicUrl)
        }
      } else {
        this.memoPicUrl = []
      }
      if (arr.indexOf('outPicUrl') != -1) {
        if (
          data.outPicUrl.constructor == String &&
          data.outPicUrl.indexOf('|||') != -1
        ) {
          var arr3 = data.outPicUrl.split('|||')
          for (let i = 0; i < arr3.length; i++) {
            this.outPicUrl.push(arr3[i])
          }
        } else {
          this.outPicUrl.push(data.outPicUrl)
        }
      } else {
        this.outPicUrl = []
      }
      console.log(
        this.inPicUrl,
        this.oilDensityPicUrl,
        this.memoPicUrl,
        this.outPicUrl
      )

      this.recordDetailsVisible = true
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.condition-bar {
  padding: 1%;
  background-color: #f2f2f2;
  label {
    padding-right: 3%;
    color: #606266;
  }
  .button-group {
    padding-top: 3%;
    text-align: center;
  }
}
.bottomSty {
  border-bottom: 1px solid #c5c5c5;
  padding-bottom: 10px;
  margin-bottom: 10px;
}

//图片
.time {
  font-size: 13px;
  color: #999;
}
.bottom {
  margin-top: 13px;
  line-height: 12px;
}
.button {
  padding: 0;
  float: right;
}
.image {
  width: 100%;
  max-height: 200px;
  display: block;
}
.clearfix:before,
.clearfix:after {
  display: table;
  content: '';
}
.clearfix:after {
  clear: both;
}
.content span {
  color: black;
  font-size: 16px;
  display: inline-block;
}
.item > h4 {
  font-size: 16px;
  color: gray;
  margin: 0;
  margin-left: 7px;
  font-weight: normal;
  line-height: 30px;
}
.content {
  display: flex;
  background: #c5c5c5;
  padding: 6px;
}
.left {
  flex: 1;
  display: flex;
  p {
    width: 70px;
    margin: 0;
    font-size: 16px;
    color: black;
  }
  span {
    margin-left: 17px;
    flex: 1;
    color: gray;
    font-size: 14px;
  }
}
.right {
  flex: 1;
  display: flex;
  p {
    width: 70px;
    margin: 0;
    font-size: 16px;
    color: black;
  }
  span {
    margin-left: 17px;
    flex: 1;
    font-size: 14px;
  }
}
.time {
  margin-left: 16px;
}
.contents {
  display: flex;
  background: #c5c5c5;
  padding: 6px;
}
.left1 {
  flex: 1;
  display: flex;
  flex-direction: column;
  div {
    flex: 1;
    display: flex;
    padding: 3px 0 3px 0;
    p {
      margin: 0;
      display: inline-block;
      // line-height: 30px;
      font-size: 16px;
      color: black;
    }
  }
}
.left2 {
  flex: 1;
  display: flex;
  flex-direction: column;
  div {
    flex: 1;
    display: flex;
    padding: 3px 0 3px 0;
    p {
      margin: 0;
      display: inline-block;
      // line-height: 30px;
      font-size: 16px;
      color: black;
    }
  }
}
.right1 {
  flex: 1;
  div {
    flex: 1;
    display: flex;
    padding: 3px 0 3px 0;
    p {
      margin: 0;
      display: inline-block;
      // line-height: 30px;
      font-size: 16px;
      color: black;
    }
  }
}
.right2 {
  flex: 1;
  display: flex;
  flex-direction: column;
  div {
    display: flex;
    padding: 3px 0 3px 0;
    p {
      margin: 0;
      display: inline-block;
      // line-height: 30px;
      font-size: 16px;
      color: black;
      flex: 2;
    }
    div {
      flex: 6;
    }
  }
}
.photo {
  flex: 6 !important;
  margin-top: 24px;
  ul {
    width: 100%;
    margin: 0;
    padding: 0;
    li {
      float: left;
      list-style: none;
      width: 32% !important;
      height: 110px;
      margin-left: 3px;
      img {
        width: 80px !important;
        height: 110px;
      }
    }
  }
}
.sunhao {
  display: flex;
}
.neirong {
  flex: 1;
  background: #c5c5c5;
  display: flex;
  padding: 6px;
  p {
    margin: 0;
    font-size: 16px;
    flex: 2;
    color: black;
  }
  div {
    flex: 6;
    display: flex;
    p {
      flex: 1;
      color: black;
    }
  }
}
.el-button--medium {
  padding: 10px 35px;
}
</style>
